<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<p-table #pt [value]="listingQualityStatuss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="qualityTestId"
  selectionMode="single" [(selection)]="listingQualityStatus" [loading]="loading"
  [paginator]="true" [rows]="250" [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <span>
        <button pButton pRipple class="p-button"
          style="padding: 0.643rem 0.75rem !important;  margin-right:10px;"
        (click)="testListingQualityStatus()">Run Quality Test</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="testResultStatusValues" appendTo="body"
          [(ngModel)]="defaultTestResultStatus" (onChange)="pt.filter($event.value, 'testResultStatus', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="testResultStatus" display="chip">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'testSubjectName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="testNameValues" appendTo="body"
          (onChange)="pt.filter($event.value, 'testName', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="testName"
          [value]="pt.filters['testName'] ? pt.filters['testName'].value : ''">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'testResultValue', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'testResultDesc', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-listingQualityStatus>
    <tr [pSelectableRow]="listingQualityStatus">
      <td [style.background-color]="getResStatusColor(listingQualityStatus.testResultStatus)">
      {{listingQualityStatus.testResultStatus}}</td>
      <td>{{listingQualityStatus.createDate | date:'MM-dd-yyyy'}} </td>
      <td>{{listingQualityStatus.testSubjectName}}</td>
      <td>{{listingQualityStatus.testName}}</td>
      <td>{{listingQualityStatus.testResultValue}}</td>
      <!-- <td>
      <textarea id="testResultDesc" [rows]="2" cols="45" pInputTextarea readonly="true">
        {{listingQualityStatus.testResultDesc}}
      </textarea>
    </td> -->
    <td colspan="2" style="white-space: pre-line;"><pre>{{listingQualityStatus.testResultDesc}}</pre></td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;"
        (click)="onOpenFormEdit(listingQualityStatus)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>